import styled from 'styled-components'

export interface ISummaryRowTP {
	key: string
	label: string
	value: number
}

export function formatApprovedPercentage(totalApproved: number, totalRejected: number): string {
	const total = totalApproved + totalRejected
	if (total <= 0) return '0,00%'
	const percentage = (totalApproved / total) * 100
	return `${percentage.toFixed(2).replace('.', ',')}%`
}

export const SummaryTableSCP = styled.div`
	.ant-table-wrapper tbody tr td {
		font-size: 15px;
	}
`
